import { marked } from "marked";
import DOMPurify from "dompurify";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

var externalStreamAbortController = null;
var externalStreamStopped = false;
var externalConversationId = null;  // 儲存對話 ID

/**
 * 與畫面同源：已 sanitize 的 HTML → 純文字（供 TTS，避免唸出標籤或 Markdown 符號）。
 */
function plainTextFromSanitizedHtml(html) {
    if (!html) {
        return "";
    }

    const doc = new DOMParser().parseFromString(html, "text/html");
    const text = doc.body.textContent || "";

    return text.replace(/\s+/g, " ").trim();
}

/**
 * API 的 reply 為 Markdown；若 TTS 只用 removeHtmlTags 會留下 **、#、- 等，與畫面差異大。
 */
function replyMarkdownToPlainTextForTts(markdown) {
    if (!markdown) {
        return "";
    }

    return plainTextFromSanitizedHtml(DOMPurify.sanitize(marked.parse(markdown)));
}

function isInactiveChatRequest(requestId) {
    return (
        requestId !== null &&
        typeof window.isCurrentChatRequest === "function" &&
        !window.isCurrentChatRequest(requestId)
    );
}

window.stopOpenAIStream = function () {
    externalStreamStopped = true;
    enableButton();
};

$(function () {
    $("#rd-stop-stream").on("click", function () {
        window.stopOpenAIStream();
    });
});

/**
 * 呼叫外部 API（透過 Laravel 代理）
 * 回傳格式：{"reply": "...", "conversationId": "..."}
 * 使用一般 AJAX，回應後以 Markdown 渲染
 */
async function sendExternalStreamMessage(message, chatId, threadId, useVoice, voiceLang, callback, requestId) {
    externalStreamStopped = false;

    const proxyUrl = $('meta[name="external-stream"]').attr("content");

    $.ajax({
        url: proxyUrl,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
            message:         message,
            thread_id:       threadId,
            conversation_id: externalConversationId,  // 帶入上一次的對話 ID
        }),
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") ?? "",
        },
        success: function (data) {
            console.log(data);
            if (isInactiveChatRequest(requestId)) return;

            $(".rd-loading-content").hide();

            if (data.error) {
                console.error("External API error:", data.error);
                $(document.getElementById("msgHistory")).append(
                    '<div class="left-item"><p>⚠️ 發生錯誤，請稍後再試。</p></div>',
                );
                enableButton();
                return;
            }

            // 記錄 conversationId 供後續對話使用
            if (data.conversation_id) {
                externalConversationId = data.conversation_id;
            }
            console.log('data',data);
            const fullText = data.reply ?? "";
            const safeHTML = DOMPurify.sanitize(marked.parse(fullText));
            const plainTextForTts = plainTextFromSanitizedHtml(safeHTML);

            // 建立並填入回答區塊
            $(document.getElementById("msgHistory")).append(
                `<div class="left-item">${safeHTML}<div class="comment-tool"><div class="good rd-click-review" data-type="2"></div><div class="none-good rd-click-review" data-type="3"></div></div></div>`,
            );

            const answerDiv = $(".left-item").last()[0];

            $("#msgHistory").find("a").attr("target", "_blank");
            scrollQuestion();
            reviewEvent();
            trackEvent();

            // 儲存歷史紀錄
            saveHistory(chatId, message, fullText, useVoice, voiceLang);

            // 回呼（TTS 等）
            if (typeof callback === "function") {
                callback(plainTextForTts, function () {
                    if (
                        requestId !== null &&
                        typeof window.finishChatRequest === "function" &&
                        window.finishChatRequest(requestId)
                    ) {
                        enableButton();
                    }
                });
            } else {
                if (
                    requestId !== null &&
                    typeof window.finishChatRequest === "function" &&
                    window.finishChatRequest(requestId)
                ) {
                    enableButton();
                }
            }
        },
        error: function (xhr, status, error) {
            if (status === "abort") return;
            console.error("External API request error:", error);
            $(".rd-loading-content").hide();
            $(document.getElementById("msgHistory")).append('<div class="left-item"><p>⚠️ 發生錯誤，請稍後再試。</p></div>');
            enableButton();
        },
    });
}

// ─── 公開 API ────────────────────────────────────────────────────────────────

window.askOpenAI = function (message, needSetQuestion = true, callback, requestId = null) {
    let threadId  = $('meta[name="thread-id"]').attr("content");
    let chatId    = $('meta[name="chat-id"]').attr("content");
    let useVoice  = $('meta[name="use-voice"]').attr("content");
    let voiceLang = $('meta[name="voice-lang"]').attr("content");

    if (needSetQuestion) {
        setQuestionContent(message);
    }

    sendExternalStreamMessage(message, chatId, threadId, useVoice, voiceLang, callback, requestId);

    $('meta[name="use-voice"]').attr("content", 0);
};

window.saveHistory = function (chatId, question, answer, useVoice, voiceLang) {
    $.ajax({
        method: "POST",
        url: $('meta[name="save-history"]').attr("content"),
        data: { chat_id: chatId, question, answer, use_voice: useVoice, voice_lang: voiceLang },
        cache: false,
        success: function (data) {
            $(".left-item").last().find(".rd-click-review").data("id", data.history_id);
        },
        error: function (e) {},
    });
};

window.removeHtmlTags = function (str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
};

/** 供除錯：比對「畫面可讀」與送 TTS 的純文字是否一致 */
window.replyMarkdownToPlainTextForTts = replyMarkdownToPlainTextForTts;

window.setQuestionContent = function (content, needLoading = true) {
    $("#rd-input-text").text("");
    $("#rd-card").hide();
    $("#rd-hello").hide();

    $("#msgHistory").append(`<div class="right-item">${content}</div>`);

    if (needLoading) {
        $("#msgHistory").append(`
            <div class="left-item rd-loading-content">
                <div class="did-loading">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
            </div>
        `);
    }

    scrollQuestion();
};

window.setAnswerContent = function (content, id) {
    $("#msgHistory").append(`
        <div class="left-item">
            ${content}
            <div class="comment-tool">
                <div class="good rd-click-review" data-id="${id}" data-type="2"></div>
                <div class="none-good rd-click-review" data-id="${id}" data-type="3"></div>
            </div>
        </div>
    `);
    $("#msgHistory").find("a").attr("target", "_blank").data("id", id);
    $(".rd-loading-content").hide();
    scrollQuestion();
    reviewEvent();
    trackEvent();
};

window.scrollQuestion = function () {
    gsap.to("#rd-did-content", {
        duration: 1,
        scrollTo: { y: $("#msgHistory").find(".right-item").last(), offsetY: 0 },
    });
};

function reviewEvent() {
    $(".rd-click-review").unbind().on("click", function () {
        let _this      = $(this);
        let type       = _this.data("type");
        let history_id = _this.data("id");

        $.ajax({
            method: "POST",
            url: $('meta[name="review"]').attr("content"),
            data: { history_id, type },
            cache: false,
            success: function () {
                _this.closest(".comment-tool").find(".rd-click-review").removeClass("now");
                _this.addClass("now");
            },
        });
    });
}

function trackEvent() {
    $("#msgHistory").find("a").unbind().on("click", function () {
        let _this      = $(this);
        let history_id = _this.data("id");
        let link       = $(this).attr("href");

        $.ajax({
            method: "POST",
            url: $('meta[name="track"]').attr("content"),
            data: { history_id, link },
            cache: false,
        });
    });
}

